import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const DiscipleProfilePage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  
  // 如果用户未登录，重定向到登录页面
  if (!user) {
    navigate('/login');
    return null;
  }
  
  return (
    <div className="space-y-8">
      <section className="cyber-panel p-6 rounded-lg bg-gradient-to-r from-cyber-dark to-black">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-3xl font-xianxia text-cyber-primary mb-2 cyber-title">弟子档案</h1>
            <p className="text-cyber-light">
              查看和管理个人修炼档案
            </p>
          </div>
        </div>
      </section>
      
      <div className="cyber-panel p-6 rounded-lg">
        <div className="text-center p-8">
          <h2 className="text-2xl font-cyber text-cyber-primary mb-4">功能开发中</h2>
          <p className="text-cyber-light mb-4">弟子档案功能正在紧张开发中，敬请期待...</p>
          <button
            className="cyber-button"
            onClick={() => navigate('/dashboard')}
          >
            返回仪表板
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscipleProfilePage;
